import React from 'react';
import { styled } from '@mui/material/styles';
import { Fab } from '@mui/material';

interface FloatingButtonProps {
  hasUnread?: boolean;
  onClick?: () => void;
}

const StyledFab = styled(Fab)(({ theme }) => ({
  backgroundColor: '#7C57FF',
  color: theme.palette.primary.contrastText,
  borderRadius: '20px',
  '&:hover': {
    backgroundColor: '#6A46E5'
  },
  '& img': {
    width: 24,
    height: 24
  }
}));

export const FloatingButton: React.FC<FloatingButtonProps> = ({
  hasUnread = false,
  onClick
}) => {
  const iconSrc = hasUnread
    ? '/assets/chat/unreadChatIcon.svg' // Path to your unread message icon
    : '/assets/chat/readChatIcon.svg'; // Default icon

  return (
    <StyledFab aria-label="Chat" color="primary" onClick={onClick}>
      <img
        src={iconSrc}
        alt={hasUnread ? 'Unread messages' : 'Chat'}
        width={24}
        height={24}
      />
    </StyledFab>
  );
};

export default FloatingButton;
